import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=ff84f162&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff84f162",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff84f162')) {
      api.createRecord('ff84f162', component.options)
    } else {
      api.reload('ff84f162', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=ff84f162&scoped=true&", function () {
      api.rerender('ff84f162', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2UCdBER602c4z/JS/comp/Accordion.vue"
export default component.exports